import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggleFilters (e) {
    e.preventDefault()
    document.querySelector('#filter-form').classList.toggle('hidden')
  }
}
